import React, { memo } from 'react';
import type { FunctionComponent, KeyboardEvent } from 'react';
import './SearchInput.scss';
import { Icon } from '@web-components-proxy';
import { SearchInputClearButton, SearchInputSearchButton } from './components';

interface SearchInputProps {
	placeholder: string;
	inputValue: string;
	touched: boolean;
	inputHandler: (val: string) => void;
	btnHandler: () => void;
	enterHandler: (e: KeyboardEvent<HTMLInputElement>, btnHandler: () => void) => void;
}

export const SearchInput: FunctionComponent<SearchInputProps> = memo(
	({ placeholder, inputValue, touched, inputHandler, btnHandler, enterHandler }) => {
		return (
			<div className="search-input">
				<Icon className="search-input__icon" iconName="search"></Icon>
				<input
					autoFocus
					className="search-input__input"
					type="text"
					placeholder={placeholder}
					onChange={e => inputHandler(e.target.value)}
					onKeyDown={e => enterHandler(e, btnHandler)}
					value={inputValue}
				/>
				<SearchInputClearButton inputHandler={inputHandler} touched={touched} />
				<SearchInputSearchButton btnHandler={btnHandler} touched={touched} />
			</div>
		);
	},
);
